module.exports = __webpack_public_path__ + "img/symbol_blue.58407507.svg";